const getInitiallyOpenNodes = nodeList => {
  const openNodes = [];

  nodeList.forEach(currentNode => {
    const splitNode = currentNode.split('.');
    splitNode.forEach((currentNode, index) => {
      if (index > 0) openNodes.push(splitNode.slice(0, index).join('.'));
    });
  });
  return openNodes;
};

export { getInitiallyOpenNodes };
